// const urlHeader='http://www.bgmsteelkscm.co.kr'
// const sysHeader = 'http://www.bgmsteelkscm.co.kr:8094'

// 正式
const urlHeader='http://www.bgmsteelkscm.co.kr'
const sysHeader = 'http://www.bgmsteelkscm.co.kr:8094'
// test
// const urlHeader='http://10.157.8.247:7092'
// const sysHeader = 'http://10.157.8.247:7094'
// dvpt
// const urlHeader='http://10.30.92.154:8092'
// const sysHeader = 'http://10.30.92.154:8094'
// const urlHeader='/api'

// const devApiUrl = {
//     //修改密码
//     password:sysHeader+'/web/sys/user/password',
//     // index
//     loginSys:sysHeader+'/web/sys',
//     updateEmail:sysHeader+'/web/sys/user/updateEmail',
//     rerss:sysHeader+'/web/pwd',
//     // updateEmail:'/web/sys/user/updateEmail',
//     loginMenuTree:sysHeader+'/web/sys/menu/tree',
//     login:sysHeader+'/web/sys/login',
//     ccc:urlHeader+'/bgm/logout',
//     platForm:urlHeader+'/bgm/sys/authority/platForm',
//     aaa:urlHeader+'/bgm/exportXls/ckCxService/queryStockOnHand/stockOnHandExpt',
//     bbb:urlHeader+'/bgm/hw/kccx/queryOutStock',
//     addCart:urlHeader+'/bgm/sc/jgsq/addCart',
//     OutStock:urlHeader+'/bgm/hw/kccx/queryOutStock',
//     OnHand:urlHeader+'/bgm/zl/zlgz/queryStockOnHand',
//     queryStockOnHand:urlHeader+'/bgm/hw/kccx/queryStockOnHand',
//     getLocale:urlHeader+'/bgm/getLocale',
    
//     // addpost
//     submitApply:urlHeader+'/bgm/sc/jgsq/submitApply',
//     deleteCart:urlHeader+'/bgm/sc/jgsq/deleteCart',
//     temporaryStorage:urlHeader+'/bgm/sc/jgsq/temporaryStorage',
//     queryCart:urlHeader+'/bgm/sc/jgsq/queryCart',
//     queryTemplate:urlHeader+'/bgm/sc/jgsq/queryTemplate',
//     outStockExpt:urlHeader+'/bgm/exportXls/ckCxService/processQueryService/outStockExpt',
//     queryJGApplyDetail:urlHeader+'/bgm/sc/jgsq/query/queryJGApplyDetail',
//     queryJGApplyHeadList:urlHeader+'/bgm/sc/jgsq/query/queryJGApplyHeadList',
//     reverseJGApply:urlHeader+'/bgm/sc/jgsq/query/reverseJGApply',
//     // applyQueryExpt:urlHeader+'/bgm/exportProcessQueryXls/processQueryService/queryApplyData/applyQueryExpt',
//     addCartByJgs:urlHeader+'/bgm/xs/thsq/addCartByJgs',
//     addCartByJg:urlHeader+'/bgm/xs/thsq/addCartByJg',
//     getBspAccessToken:urlHeader+'/bgm/zl/zlgz/getBspAccessToken',
//     applyQueryExpt:urlHeader+'/bgm/exportProcessQueryXlsDown/processQueryService/queryApplyData/applyQueryExpt',


//     // delivery
//     addDeliveryCart:urlHeader+'/bgm/xs/thsq/addDeliveryCart',
//     addDeliveryPlan:urlHeader+'/bgm/xs/thsq/addDeliveryPlan',
//     queryDeliveryCart:urlHeader+'/bgm/xs/thsq/queryDeliveryCart',
//     queryDeliveryCarts:urlHeader+'/bgm/xs/thsq/queryDeliveryCarts',
//     queryDeliveryPlan:urlHeader+'/bgm/xs/thsq/queryDeliveryPlan',
//     queryDeliveryPlans:urlHeader+'/bgm/xs/thsq/queryDeliveryPlans',
//     deleteDeliveryCart:urlHeader+'/bgm/xs/thsq/deleteDeliveryCart',
//     deleteDeliveryPlan:urlHeader+'/bgm/xs/thsq/deleteDeliveryPlan',
//     temporaryDeliveryCartStorage:urlHeader+'/bgm/xs/thsq/temporaryDeliveryPlanStorage',
//     submitDeliveryPlanApply:urlHeader+'/bgm/xs/thsq/submitDeliveryPlanApply',
//     settlementCurrency:urlHeader+'/bgm/sys/cs/settlementCurrency',
//     modeofDelivery:urlHeader+'/bgm/sys/cs/modeofDelivery',
//     placeofDelivery:urlHeader+'/bgm/sys/cs/placeofDelivery',
//     submitDeliveryCartApply:urlHeader+'/bgm/xs/thsq/submitDeliveryCartApply',
//     packageTogether:urlHeader+'/bgm/xs/thsq/query/packageTogether',
//     turnToWarehouse:urlHeader+'/bgm/xs/thsq/query/turnToWarehouse',
//     categoryCodeDrop:urlHeader+'/bgm/sys/cs/categoryCodeDrop',
//     shopsignDrop:urlHeader+'/bgm/sys/cs/shopsignDrop',
//     warehouseNameDrop:urlHeader+'/bgm/sys/cs/warehouseNameDrop',



//     // ladingsee
//     queryOntOutApplyHead:urlHeader+'/bgm/xs/thsq/query/queryOntOutApplyHead',
//     queryOntOutApplyLine:urlHeader+'/bgm/xs/thsq/query/queryOntOutApplyLine',
//     reverseTHApply:urlHeader+'/bgm/xs/thsq/query/reverseTHApply',
//     tHapplyQueryExpt:urlHeader+'/bgm/exportProcessQueryXls/deliveryQueryService/queryApplyData/tHapplyQueryExpt',

//     // lading
//     queryXSOntOutApplyHead:urlHeader+'/bgm/xs/thsq/query/queryXSOntOutApplyHead',
//     queryXSOntOutApplyLine:urlHeader+'/bgm/xs/thsq/query/queryXSOntOutApplyLine',
//     //addmeautwo
//     outStockExpt2:urlHeader+'/bgm/exportXls/ckCxService/queryOutStockPack/outStockExpt',
//     queryStockOnHand2:urlHeader+'/bgm/kccx/queryStockOnHand',
//     queryClearinguser:urlHeader+'/bgm/sys/cs/queryClearinguser',
//     // Original
//     outlibraryExpt:urlHeader+'/bgm/exportXlsDown/deliveryQueryService/queryPlanData/outlibraryExpt',
//     cancleApplyPlan:urlHeader+'/bgm/xs/thsq/query/cancleApplyPlan',
//     // qualitative
//     QualityInfos:urlHeader+'/bgm/zl/zlgz/getQualityInfos',
//     sendEmail:urlHeader+'/bgm/co/msg/sendEmail',

// };
const devApiUrl = {
    //修改密码
    password:sysHeader+'/web/sys/user/password',
    // index
    loginSys:sysHeader+'/web/sys',
    updateEmail:sysHeader+'/web/sys/user/updateEmail',
    rerss:sysHeader+'/web/pwd',
    // updateEmail:'/web/sys/user/updateEmail',
    loginMenuTree:sysHeader+'/web/sys/menu/tree',
    login:sysHeader+'/web/sys/login',
    ccc:urlHeader+'/logout',
    platForm:urlHeader+'/sys/authority/platForm',
    aaa:urlHeader+'/exportXls/ckCxService/queryStockOnHand/stockOnHandExpt',
    bbb:urlHeader+'/hw/kccx/queryOutStock',
    addCart:urlHeader+'/sc/jgsq/addCart',
    OutStock:urlHeader+'/hw/kccx/queryOutStock',
    OnHand:urlHeader+'/zl/zlgz/queryStockOnHand',
    queryStockOnHand:urlHeader+'/hw/kccx/queryStockOnHand',
    getLocale:urlHeader+'/getLocale',
    
    // addpost
    submitApply:urlHeader+'/sc/jgsq/submitApply',
    deleteCart:urlHeader+'/sc/jgsq/deleteCart',
    temporaryStorage:urlHeader+'/sc/jgsq/temporaryStorage',
    queryCart:urlHeader+'/sc/jgsq/queryCart',
    queryTemplate:urlHeader+'/sc/jgsq/queryTemplate',
    outStockExpt:urlHeader+'/exportXls/ckCxService/processQueryService/outStockExpt',
    queryJGApplyDetail:urlHeader+'/sc/jgsq/query/queryJGApplyDetail',
    queryJGApplyHeadList:urlHeader+'/sc/jgsq/query/queryJGApplyHeadList',
    reverseJGApply:urlHeader+'/sc/jgsq/query/reverseJGApply',
    // applyQueryExpt:urlHeader+'/exportProcessQueryXls/processQueryService/queryApplyData/applyQueryExpt',
    addCartByJgs:urlHeader+'/xs/thsq/addCartByJgs',
    addCartByJg:urlHeader+'/xs/thsq/addCartByJg',
    getBspAccessToken:urlHeader+'/zl/zlgz/getBspAccessToken',
    applyQueryExpt:urlHeader+'/exportProcessQueryXlsDown/processQueryService/queryApplyData/applyQueryExpt',


    // delivery
    addDeliveryCart:urlHeader+'/xs/thsq/addDeliveryCart',
    addDeliveryPlan:urlHeader+'/xs/thsq/addDeliveryPlan',
    queryDeliveryCart:urlHeader+'/xs/thsq/queryDeliveryCart',
    queryDeliveryCarts:urlHeader+'/xs/thsq/queryDeliveryCarts',
    queryDeliveryPlan:urlHeader+'/xs/thsq/queryDeliveryPlan',
    queryDeliveryPlans:urlHeader+'/xs/thsq/queryDeliveryPlans',
    deleteDeliveryCart:urlHeader+'/xs/thsq/deleteDeliveryCart',
    deleteDeliveryPlan:urlHeader+'/xs/thsq/deleteDeliveryPlan',
    temporaryDeliveryCartStorage:urlHeader+'/xs/thsq/temporaryDeliveryPlanStorage',
    submitDeliveryPlanApply:urlHeader+'/xs/thsq/submitDeliveryPlanApply',
    settlementCurrency:urlHeader+'/sys/cs/settlementCurrency',
    modeofDelivery:urlHeader+'/sys/cs/modeofDelivery',
    placeofDelivery:urlHeader+'/sys/cs/placeofDelivery',
    submitDeliveryCartApply:urlHeader+'/xs/thsq/submitDeliveryCartApply',
    packageTogether:urlHeader+'/xs/thsq/query/packageTogether',
    turnToWarehouse:urlHeader+'/xs/thsq/query/turnToWarehouse',
    categoryCodeDrop:urlHeader+'/sys/cs/categoryCodeDrop',
    shopsignDrop:urlHeader+'/sys/cs/shopsignDrop',
    warehouseNameDrop:urlHeader+'/sys/cs/warehouseNameDrop',



    // ladingsee
    queryOntOutApplyHead:urlHeader+'/xs/thsq/query/queryOntOutApplyHead',
    queryOntOutApplyLine:urlHeader+'/xs/thsq/query/queryOntOutApplyLine',
    reverseTHApply:urlHeader+'/xs/thsq/query/reverseTHApply',
    tHapplyQueryExpt:urlHeader+'/exportProcessQueryXls/deliveryQueryService/queryApplyData/tHapplyQueryExpt',

    // lading
    queryXSOntOutApplyHead:urlHeader+'/xs/thsq/query/queryXSOntOutApplyHead',
    queryXSOntOutApplyLine:urlHeader+'/xs/thsq/query/queryXSOntOutApplyLine',
    //addmeautwo
    outStockExpt2:urlHeader+'/exportXls/ckCxService/queryOutStockPack/outStockExpt',
    queryStockOnHand2:urlHeader+'/kccx/queryStockOnHand',
    queryClearinguser:urlHeader+'/sys/cs/queryClearinguser',
    // Original
    outlibraryExpt:urlHeader+'/exportXlsDown/deliveryQueryService/queryPlanData/outlibraryExpt',
    cancleApplyPlan:urlHeader+'/xs/thsq/query/cancleApplyPlan',
    // qualitative
    QualityInfos:urlHeader+'/zl/zlgz/getQualityInfo',
    sendEmail:urlHeader+'/co/msg/sendEmail',

};

const prodApiUrl = {

};

const apiConfig =  devApiUrl ;

export default apiConfig;



// WEBPACK FOOTER //
// ./src/config/apiConfig.js